import axios from 'axios';
import { call, put } from 'redux-saga/effects';

// CONSTANTS
import { CHARTS_GET_PERIODS, CHARTS_GET } from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';

import { ChartsActions } from '@/store/actions';

const { getCharts, getChartsPeriods } = ChartsActions;

export function* getChartsPeriodsSaga() {
  yield put({ type: getChartsPeriods.types.START });

  try {
    const { data: respData } = yield axios.get(CHARTS_GET_PERIODS);

    yield put({
      type: getChartsPeriods.types.SUCCESS,
      payload: {
        periods: respData,
      },
    });

    return respData;
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getChartsPeriods.types.FAIL,
    });

    return null;
  }
}

export function* getChartsSaga(action) {
  yield put({ type: getCharts.types.START });
  const params = action?.payload?.params || { date_from: null, date_to: null };

  try {
    if (params.date_from === null && params.date_to === null) {
      const periodsRespData = yield call(getChartsPeriodsSaga);

      if (periodsRespData) {
        const firstPeriod = periodsRespData[0];
        params.date_from = firstPeriod.date_from;
        params.date_to = firstPeriod.date_to;
      }
    }

    const { data: respData } = yield axios.get(CHARTS_GET, { params });

    yield put({
      type: getCharts.types.SUCCESS,
      payload: {
        data: respData,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getCharts.types.FAIL,
    });
  }
}

export default getChartsSaga;
